export default __webpack_public_path__ + "static/media/OKE.4a86821b.jpg";